import React from 'react';
import styled from 'styled-components';
import Proptypes from 'prop-types';

const StyledRadio = styled.span`
  height: 20px;
  border-radius: 50%;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  color: ${({ value, theme }) => (value ? theme.primary : theme.inputBorder)};
  transition: background-color 0.3s ease;
  border: 2px solid
    ${({ value, theme }) => (value ? theme.primary : theme.dark60)};
  cursor: pointer;

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.primary};
  }
`;
const StyledRadioButton = ({
  value,
  onChange,
  label,
  disabled,
  hasNoLabel,
  radioLabelClassName = '',
  id,
}) => {
  const onChangeRadio = (event) => {
    if (onChange) {
      onChange(event);
    }
  };
  return (
    <>
      <StyledLabel
        htmlFor={id ?? label}
        className={`d-flex align-items-center mb-0 me-2 ${radioLabelClassName}`}
        style={{ cursor: 'pointer' }}
      >
        <div>
          <StyledRadio value={value}>
            {value && <span className="dot" />}
          </StyledRadio>
        </div>
        {label && !hasNoLabel && (
          <span className="ms-2 text-nowrap radio-field-label">{label}</span>
        )}
      </StyledLabel>
      <input
        id={id ?? label}
        type="radio"
        style={{ display: 'none' }}
        checked={value}
        disabled={disabled}
        onChange={onChangeRadio}
      />
    </>
  );
};

const StyledLabel = styled.label`
  .radio-field-label {
    color: ${({ theme }) => theme.heading};
    font-size: 18px;
  }
`;
StyledRadioButton.propTypes = {
  value: Proptypes.bool,
  onChange: Proptypes.func,
  label: Proptypes.string,
};

export default StyledRadioButton;
